export { default as submitFormData } from './submitFormData';
export { default as getModuleContext } from './getModuleContext';
export { default as handleAdFormLayoutMobile } from './handleAdFormLayoutMobile';



// WEBPACK FOOTER //
// ./src/HOCs/index.ts